var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"card-holder-cell"},[_c('span',{staticClass:"card-holder-cell__name"},[_vm._v(_vm._s(_vm.holder))]),_vm._v(" "),(_vm.showNameOnCard)?_c('span',{staticClass:"card-holder-cell__name-on-card"},[_vm._v(_vm._s(_vm.nameOnCard))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e3d8623","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Programs/Card-cards/CardHolder.vue
// module id = W4pV
// module chunks = 12